// extracted by mini-css-extract-plugin
export default {"main":"BetNotStarted_main__DcxQZ","notStartedText":"BetNotStarted_notStartedText__mFQsv"};